import React from 'react';
import CloseButton from '../components/CloseButton';
import PinchZoomPanContainer from '../weather/PinchZoomPanContainer';
 
export default function ImageDisplayPanel({ onClose, src, title }) {
  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      width: '100vw',
      height: '100vh',
      background: 'rgba(0,0,0,0.5)',
      zIndex: 9000,
      display: 'flex',
      flexDirection: 'column'
    }}>
      <CloseButton
        onClick={onClose}
        style={{ position: 'absolute', top: 18, right: 24 }}
        zIndex={9100}
      />
      <div
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden'
        }}
      >
        <PinchZoomPanContainer
          style={{
            width: '100vw',
            height: '100vh',
            background: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <div
            style={{
              background: '#fff',
              borderRadius: 12,
              padding: 10,
              boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <img
              src={src}
              alt={title || 'image'}
              style={{
                maxHeight: '92vh',
                maxWidth: '92vw',
                width: 'auto',
                height: 'auto',
                userSelect: 'none',
                display: 'block'
              }}
              draggable={false}
            />
          </div>
        </PinchZoomPanContainer>
      </div>
    </div>
  );
}
